"use strict";

exports.__esModule = true;
exports.InternalModalFooter = exports.ModalFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactConfig = require("@okee-uikit/react-config");

var _reactHooks = require("@okee-uikit/react-hooks");

var _reactUtils = require("@okee-uikit/react-utils");

var _button = require("../button");

var _excluded = ["className", "align", "children"],
    _excluded2 = ["className", "align", "showCancelButton", "cancelButtonProps", "cancelButtonclassName", "onCancelCallback", "cancelText", "okButtonclassName", "okButtonProps", "onOkCallback", "okText"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalFooter = function ModalFooter(props) {
  var _usePrefixCls;

  var className = props.className,
      _props$align = props.align,
      align = _props$align === void 0 ? 'start' : _props$align,
      children = props.children,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var cls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('modal-footer', (_usePrefixCls = {}, _usePrefixCls["align-" + align] = true, _usePrefixCls)), className);
  return _react.default.createElement("div", _extends({
    className: cls
  }, attrs), children);
};

exports.ModalFooter = ModalFooter;
ModalFooter.displayName = 'ModalFooter';

var InternalModalFooter = _react.default.forwardRef(function (props, ref) {
  var className = props.className,
      _props$align2 = props.align,
      align = _props$align2 === void 0 ? 'start' : _props$align2,
      showCancelButton = props.showCancelButton,
      cancelButtonProps = props.cancelButtonProps,
      cancelButtonclassName = props.cancelButtonclassName,
      onCancelCallback = props.onCancelCallback,
      cancelText = props.cancelText,
      okButtonclassName = props.okButtonclassName,
      okButtonProps = props.okButtonProps,
      onOkCallback = props.onOkCallback,
      okText = props.okText,
      extra = _objectWithoutPropertiesLoose(props, _excluded2);

  var _useBoolean = (0, _reactHooks.useBoolean)(false),
      confirmLoading = _useBoolean[0],
      _useBoolean$ = _useBoolean[1],
      showLoading = _useBoolean$.setTrue,
      hideLoading = _useBoolean$.setFalse;

  _react.default.useImperativeHandle(ref, function () {
    return {
      showLoading: showLoading,
      hideLoading: hideLoading
    };
  });

  return _react.default.createElement(ModalFooter, _extends({
    className: className,
    align: align
  }, extra), showCancelButton && _react.default.createElement(_button.Button, _extends({
    type: "default"
  }, cancelButtonProps, {
    className: cancelButtonclassName,
    onClick: onCancelCallback
  }), cancelText), _react.default.createElement(_button.Button, _extends({
    type: "primary",
    className: okButtonclassName,
    loading: confirmLoading,
    onClick: onOkCallback
  }, okButtonProps), okText));
});

exports.InternalModalFooter = InternalModalFooter;